import React from 'react';
import { motion } from 'framer-motion';
export const CTAButton = ({
  className = '',
  onClick
}: {
  className?: string;
  onClick?: () => void;
}) => {
  return <motion.a href="https://mujercashflow.com/cart/46676096385214:1" onClick={onClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`inline-block w-full sm:w-auto text-center bg-rose-500 hover:bg-rose-600 text-white font-medium text-lg sm:text-xl py-4 sm:py-5 px-8 sm:px-10 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 ${className}`} data-id="element-261">
      <span className="block mb-1" data-id="element-262">🌸 SÍ, ME ELIJO A MÍ MISMA</span>
      <span className="block text-sm sm:text-base font-normal opacity-90" data-id="element-263">
        QUIERO MI COPIA POR SOLO $6.39 USD
      </span>
    </motion.a>;
};
export const Section = ({
  children,
  className = '',
  id
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => {
  return <section id={id} className={`py-8 sm:py-24 px-4 sm:px-6 ${className}`} data-id="element-264">
      <div className="max-w-3xl mx-auto" data-id="element-265">{children}</div>
    </section>;
};
export const FadeIn = ({
  children,
  delay = 0
}: {
  children: React.ReactNode;
  delay?: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 0.7,
  delay
}} data-id="element-266">
    {children}
  </motion.div>;